import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Account } from '../../objects/account';
import {DialogCanvasComponent} from "../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {AppComponent} from "../../app.component";
import {AppEvent} from "../../objects/appEvent";
import {SubscriptionLike} from "rxjs/index";
import {SharedDataService} from "../../services/shared-data.service";
import {FS3Notification} from "../../objects/notification";

@Component({
  selector: 'app-article-view-container',
  templateUrl: './article-view-container.component.html',
  styleUrls: ['./../../app.component.scss']
})
export class ArticleViewContainerComponent implements OnInit, OnDestroy {

  @Input()
  public account: Account;
  @Input()
  public application: AppComponent;

  public dialogRef: MatDialogRef<DialogCanvasComponent>
  private userLoginSubscription: SubscriptionLike;

  constructor(private sharedDataService: SharedDataService,
              public dialog: MatDialog) { }

  ngOnInit(): void {
    this.userLoginSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.USER_HAS_BEEN_LOGGED) {
          if(this.dialogRef) {
            this.dialogRef.close();
            const note = new FS3Notification();
            note.type = 'success';
            note.text = 'Welcome!';
            this.sharedDataService.pushNotification(note)
          }
        }
        if (appEvent.type === AppEvent.SHOW_LOGIN_FROM_STATIC_ARTICLE) {
          this.showLoginPopup()
        }
      });
  }
  ngOnDestroy() {
    this.userLoginSubscription.unsubscribe();
  }

  showLoginPopup() {
    this.dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: 'auto',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '100%' : '432px',
      data: {
        application: this.application,
        state: 'popup-login',
        payload: {

        }
      }
    } as MatDialogConfig);
    this.dialogRef.addPanelClass('common-dialog');
    this.dialogRef.addPanelClass('common-dialog-medium-form');
    this.dialogRef.afterOpened().subscribe(() => {
      (this.dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
  }

}
